import React from 'react'

export default function CaseStudy() {

    const reasons = [
        "Integrity",
        "Excellence",
        "Collaboration",
        "Customer Focus",
        "Innovation",
        "Trust"
    ]

    // const reasonsDescription = [
    //     "We conduct our business with the highest level of integrity, transparency, and honesty. We believe in upholding ethical standards and building trust with our clients, partners, and suppliers.",
    // ]

  return (
    <div className='mt-32 px-4'>
      
      <div>

<p className='text-2xl uppercase text-green-500 text-center'> Case Study</p>
<p className='text-5xl text-center my-4'> Why Choose US? </p>

<div className='flex flex-wrap gap-6 justify-center'>

{
    reasons.map((reason,index)=>(

        <div className='w-96 h-60 group relative hover:bg-green-400 transition-all duration-200 bg-green-200 flex justify-center items-center rounded-xl'>

<p className='text-3xl bg-transparent '> {reason} </p>
{/* <p className='bg-transparent opacity-0  absolute text-xl bg-gray-100 group-hover:opacity-100 h-full rounded-xl p-4 text-center flex justify-center  items-center transition-all duration-300'> {reasonsDescription[index]} </p> */}

        </div>

    ))
}


</div>

      </div>

    </div>
  )
}
